import { BsSearch } from 'react-icons/bs';
import { typeMapGeriatrico } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';
import React, { useState } from 'react';

interface GeriatricsTableProps {
    geriatricos: typeMapGeriatrico[];
    onEdit: (geriatrico: typeMapGeriatrico) => void;
    onDelete: (id: number) => void;
    onToggleActivo: (id: number) => void;
    onAddManual: () => void;
    onImportKMZ: () => void;
    loading: boolean;
    importingInfo: string | null;
};

export const GeriatricsTable: React.FC<GeriatricsTableProps> = ({
    geriatricos,
    onEdit,
    onDelete,
    onToggleActivo,
    onAddManual,
    onImportKMZ,
    loading,
    importingInfo
}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const isDarkMode = useGetIsDarkMode();

    const filteredGeriatricos = geriatricos.filter(g => {
        const term = searchTerm.toLowerCase();
        return (
            g.nombre.toLowerCase().includes(term) ||
            g.direccion.toLowerCase().includes(term) ||
            (g.hermanosAsignados && g.hermanosAsignados.some(h => h.toLowerCase().includes(term))) ||
            (g.territorio && g.territorio.toLowerCase().includes(term)) ||
            (g.estado && g.estado.toLowerCase().includes(term))
        );
    });

    return (
        <div className="mt-5">
            <h3 className="text-center mb-3">Geriátricos en el mapa</h3>
            
            <div className="row justify-content-center mb-4">
                <div className="col-md-6">
                    <div className="input-group">
                        <span className="input-group-text bg-white border-end-0">
                            <BsSearch className="text-muted" />
                        </span>
                        <input 
                            type="text" 
                            className="form-control border-start-0 ps-0" 
                            placeholder="Buscar por nombre, dirección o hermano..." 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                            <button className="btn btn-outline-secondary border-start-0" onClick={() => setSearchTerm("")}>
                                Limpiar
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center gap-2 mb-4">
                <button className="btn btn-success" onClick={onAddManual} disabled={loading}>
                    Agregar geriátrico manualmente
                </button>
                <button className="btn btn-primary" onClick={onImportKMZ} disabled={loading}>
                    Importar KMZ
                </button>
            </div>
            
            {importingInfo && (
                <div className="alert alert-info py-2 mb-3 text-center">
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    {importingInfo}
                </div>
            )}

            <div className="table-responsive">
                <table className={`table table-bordered ${isDarkMode ? 'table-dark' : ''} table-sm align-middle`}>
                    <thead>
                        <tr>
                            <th>Territorio</th>
                            <th>Nombre</th>
                            <th>Dirección</th>
                            <th>Estado</th>
                            <th>Contacto</th>
                            <th>Asignados</th>
                            <th className="text-center">Activo</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredGeriatricos.map(f => (
                            <tr key={f.id} className={!f.activo ? 'table-light opacity-50' : ''}>
                                <td>{f.territorio || '-'}</td>
                                <td>{f.nombre}</td>
                                <td>{f.direccion}</td>
                                <td>{f.estado || '-'}</td>
                                <td>
                                    {f.telefono && <div><a href={`tel:${f.telefono}`} className="text-decoration-none">📞 {f.telefono}</a></div>}
                                </td>
                                <td>
                                    {f.hermanosAsignados && f.hermanosAsignados.filter(h => h).join(', ') || '-'}
                                </td>
                                <td className={'text-center'}>
                                    <input type={'checkbox'}
                                        className={'form-check-input checkbox-blue checkbox-md me-2'}
                                        checked={f.activo}
                                        onChange={() => onToggleActivo(f.id)} 
                                        disabled={loading}
                                    />
                                </td>
                                <td>
                                    <div className="d-flex flex-column gap-1">
                                        <button className="btn btn-general-blue btn-sm" onClick={() => onEdit(f)} disabled={loading}>
                                            Modificar
                                        </button>
                                        <button className="btn btn-general-red btn-sm" onClick={() => onDelete(f.id)} disabled={loading}>
                                            {loading ? '...' : 'Baja'}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
